document.addEventListener("DOMContentLoaded", (e) => {
  // 	fetch(window.Shopify.routes.root + 'products/arouse.js')
  // 		.then(response => response.json())
  // 		.then(product => trace(product));

  gsap.config({ nullTargetWarn: false });

  const shop_items = [
    {
      link: `${window.rootUrl}/products/throuple-bundle`,
      image:
        "https://cdn.shopify.com/s/files/1/0638/1505/7573/files/throuple-new.png?v=1742319212",
      text: "XOMD™ Throuple Bundle",
    },
    {
      link: `${window.rootUrl}/products/detox`,
      image:
        "https://cdn.shopify.com/s/files/1/0638/1505/7573/files/detox-trans_1.png?v=1742319094",
      text: "XOMD™ Detox Cleanser",
    },
    {
      link: `${window.rootUrl}/products/intoxicate`,
      image:
        "https://cdn.shopify.com/s/files/1/0638/1505/7573/files/intoxicatepng.png?v=1742319094",
      text: "XOMD™ Intoxicate Serum",
    },
    {
      link: `${window.rootUrl}/products/arouse`,
      image:
        "https://cdn.shopify.com/s/files/1/0638/1505/7573/files/arousepng.webp?v=1742319094",
      text: "XOMD™ Arouse Moisturizer",
    },
    {
      link: `${window.rootUrl}/products/igniter-kit`,
      image:
        "https://cdn.shopify.com/s/files/1/0638/1505/7573/files/IgniterKit_3.png?v=1766097938",
      text: "XOMD™ Igniter Kit",
    },
    // {
    //   link: `${window.rootUrl}/products/conversation-igniters`,
    //   image:
    //     "https://xomdskin.com/cdn/shop/files/XOMD_Product_Listing_Images_1.png?v=1750713936",
    //   text: "XOMD™ Conversation Igniters",
    // },
    {
      link: `${window.rootUrl}/products/xomd-gift-card`,
      image:
        "https://cdn.shopify.com/s/files/1/0638/1505/7573/files/XOMD-GIFT-CARD.png?v=1742319093",
      text: "XOMD™ Gift Card",
    },
  ];

  const desktop_nav = document.querySelector(
    ".header__nav-items > li:first-of-type"
  );
  const existing_nav_dropdown = desktop_nav.querySelector(
    ".header__nav-dropdown.js-dropdown"
  );
  if (existing_nav_dropdown) {
    desktop_nav.removeChild(existing_nav_dropdown);
  }

  let output = "";
  shop_items.forEach(function (item, index, array) {
    output +=
      '<a href="' +
      item.link +
      '"><div class="image"><img alt="" src="' +
      item.image +
      '"></div>' +
      item.text +
      "</a>";
  });

  const desktop_shop_dropdown = document.createElement("div");
  desktop_shop_dropdown.classList.add("header__nav-dropdown");
  desktop_shop_dropdown.classList.add("js-dropdown");
  desktop_shop_dropdown.innerHTML = output;
  desktop_nav.appendChild(desktop_shop_dropdown);

  const mobile_nav_shop_items = document.querySelectorAll(
    "#Details-menu-drawer-menu-item-1 li"
  );
  mobile_nav_shop_items.forEach(function (element, index, array) {
    element.parentNode.removeChild(element);
  });

  output = "";
  shop_items.forEach(function (item, index, array) {
    output +=
      '<li class="drawer__submenu-first-item"><a href="' +
      item.link +
      '" class="drawer__submenu-link color-body-text"><div class="image"><img alt="" src="' +
      item.image +
      '"></div>' +
      item.text +
      "</a></li>";
  });

  document.querySelector(
    "#Details-menu-drawer-menu-item-1 .drawer__menu"
  ).innerHTML = output;

  //center nav dropdown panels beneath parent link:
  const nav_panels = document.querySelectorAll(
    ".header__nav-items > li:not(:first-of-type) .header__nav-dropdown"
  );

  window.addEventListener("resize", positionNavPanels);
  positionNavPanels();

  function positionNavPanels() {
    nav_panels.forEach(function (panel, index, array) {
      const link = panel.parentNode.querySelector(".header__nav-link");
      panel.style.transform =
        "translateX(calc(" +
        link.getBoundingClientRect().width * 0.5 +
        "px - 50%))";
    });
  }

  /// VIDEO MODAL BUTTON EVENT LISTENER
  const watch_the_video = document.querySelector(
    'section [href*="#watch-the-video"]'
  );
  const video_modal = document.querySelector("xomd-video-modal-overlay");
  if (watch_the_video && video_modal) {
    watch_the_video.addEventListener("click", function (e) {
      e.preventDefault();
      video_modal.open();
    });
  }

  const ingredients_video = document.querySelector(
    '[href*="#ingredients"]'
  );
  const ingredients_video_modal = document.querySelector(
    "xomd-ingredients-video-modal-overlay"
  );
  if (ingredients_video && ingredients_video_modal) {
    ingredients_video.addEventListener("click", function (e) {
      e.preventDefault();
      ingredients_video_modal.open();
    });
  }
  ///END OF VIDEO MODAL BUTTON EVENT LISTENER

  const svg = document.querySelector("#lines-pattern");
  if (svg) {
    const guide_group = document.querySelector("#lines-pattern-guides");
    const guides = document.querySelectorAll("#lines-pattern-guides path");
    const lines_group = document.querySelector("#lines-pattern-lines");
    const lines = document.querySelectorAll("#lines-pattern-lines path");
    guides.forEach(function (path, index, array) {
      //SVG mask: Everything under a white pixel will be visible; Everything under a black pixel will be invisible:
      const mask = createSVGElement("mask", svg);
      mask.setAttribute("id", "guide-mask-" + index);
      const path_length = path.getTotalLength();
      for (let i = 0; i < path_length; i += 36) {
        const point = path.getPointAtLength(i);
        const control = createSVGElement("circle", mask);
        gsap.set(control, {
          attr: {
            stroke: "none",
            fill: "#000",
            r: 36,
            cx: point.x,
            cy: point.y,
          },
        });
      }
      lines[index].setAttribute("mask", "url(#guide-mask-" + index + ")");

      guide_group.removeChild(path);

      const mask_circles = gsap.utils.toArray(
        "#guide-mask-" + index + " circle"
      );
      const data = { p: 0 };
      gsap.to(data, {
        duration: 3.0,
        delay: index * 0.1,
        p: mask_circles.length - 1,
        onUpdate: function () {
          const i = Math.round(data.p);
          gsap.set(mask_circles.slice(0, i), { attr: { fill: "#fff" } });
        },
      });
    });

    gsap.to(".xomd-video-hero .hero__button", {
      duration: 0.35,
      delay: 2.0,
      autoAlpha: 1,
    });

    svg.style.visibility = "visible";
  }

  const lines_pattern = document.querySelectorAll(".xomd-lines-pattern");
  lines_pattern.forEach(function (svg, pattern_index) {
    const lines = svg.querySelectorAll("g:first-of-type path");
    const guides_group = svg.querySelector("g:last-of-type");
    const guides = guides_group.querySelectorAll("path");

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: svg,
        start: "top+=20% 66.666%",
      },
    });
    guides.forEach(function (path, guide_index, array) {
      //create a mask for "line":
      const id = "pattern-" + pattern_index + "-guide-mask-" + guide_index;
      //SVG mask: Everything under a white pixel will be visible; Everything under a black pixel will be invisible:
      const mask = createSVGElement("mask", svg);
      mask.setAttribute("id", id);

      //set circles in the mask along the guide:
      const path_length = path.getTotalLength();
      for (let i = 0; i < path_length; i += 18) {
        const point = path.getPointAtLength(i);
        const control = createSVGElement("circle", mask);
        gsap.set(control, {
          attr: {
            stroke: "none",
            fill: "#000",
            r: 18,
            cx: point.x,
            cy: point.y,
          },
        });
      }
      lines[guide_index].setAttribute("mask", "url(#" + id + ")");

      guides_group.removeChild(path);

      //turn circles to white over time, revealing masked line:
      const mask_circles = gsap.utils.toArray("#" + id + " circle");
      const data = { p: 0 };
      timeline.to(
        data,
        {
          duration: 1.0,
          delay: guide_index * 0.1,
          p: mask_circles.length,
          onUpdate: function () {
            const i = Math.round(data.p);
            gsap.set(mask_circles.slice(0, i), { attr: { fill: "#fff" } });
          },
        },
        0.0
      );
    });

    svg.style.visibility = "visible";
  });

  //fade elements in on scroll:
  gsap.registerPlugin(ScrollTrigger);
  const triggers = [
    // ".stats-list .stats-list-desktop",
    // ".stats-list .stats-list-mobile-container",
    // ".stats-list .stats-list-headings",
    ".products-triptych",
    ".featured-content .container",
    ".how-to-use-body",
    ".hero__content",
    ".rich-content-content",
    ".xomd-featured .section-seo-content__content",
    ".xomd-home-full-width-banner .section-full-width-banner__content",
    ".side-by-side .side-by-side-content",
    ".four-column-tiles .four-column-tiles-row",
    ".media-with--content",
    ".stats-carousel"
  ];
  triggers.forEach(function (trigger) {
    ScrollTrigger.create({
      trigger: trigger,
      scroller: "body",
      // markers: true,
      start: "top+=20% 66.666%",
      animation: gsap.from(trigger + " > *", {
        y: 100,
        autoAlpha: 0,
        stagger: 0.1,
      }),
    });
  });

  ////////////////////////////////////////////////////////////////////////////////////////
  //main product container:
  // 	const product = document.querySelector('section.xomd-product');
  // 	const product_videos = product.querySelectorAll('video');
  // 	product_videos.forEach(function(video, index, array){
  // 		video.setAttribute('playsinline', false);
  // 		video.setAttribute('muted', false);
  // 	});

  const gift_card_main = document.querySelector(
    "section.product-id-8805075517605"
  );
  if (gift_card_main) {
    const selector = gift_card_main.querySelector("product-selector");
    const quantity = gift_card_main.querySelector(
      ".product-selector__quantity "
    );

    const parent = gift_card_main.querySelector("product-form > form");
    const newdiv = document.createElement("div");
    newdiv.setAttribute("class", "gift-card-form-row");
    parent.insertBefore(newdiv, parent.childNodes[0]);
    newdiv.appendChild(selector);
    newdiv.appendChild(quantity);
  }
});

//TESTIMONIALS
customElements.define(
  "xomd-slider",
  class extends HTMLElement {
    slides;
    indicators = [];
    current_index = 0;

    constructor() {
      super();
    }

    //fires when component is attached to DOM
    connectedCallback() {
      const component = this;

      component.slides = component.querySelectorAll(".slide");

      component.querySelector(".slider-track").style.width =
        100 * component.slides.length + "%";

      const indicators = component.querySelector("nav .indicators");

      component.slides.forEach(function (element, index, array) {
        element.style.width = 100 / component.slides.length + "%";
        element.style.left = -100 * (index / component.slides.length) + "%";

        const button = document.createElement("button");
        button.classList.toggle("active", index == 0);
        indicators.appendChild(button);
        button.addEventListener("click", function (e) {
          component.current_index = index;
          component.advance();
        });

        component.indicators.push(button);
      });

      component
        .querySelector("nav .prev")
        .addEventListener("click", function (e) {
          component.current_index -= 1;
          component.current_index =
            component.current_index < 0
              ? component.slides.length - 1
              : component.current_index;
          component.advance();
        });
      component
        .querySelector("nav .next")
        .addEventListener("click", function (e) {
          component.current_index += 1;
          component.current_index =
            component.current_index >= component.slides.length
              ? 0
              : component.current_index;
          component.advance();
        });

      window.addEventListener("resize", function (e) {
        // 			let videos = parseInt(component.getAttribute('data-xomd-videos'));
        // 			let max_index = (window.innerWidth < 750) ? videos-1 : videos-3;
        // 			let current_index = parseInt(component.getAttribute('data-xomd-index'));
        // 			component.setAttribute('data-xomd-index', Math.min(max_index, current_index));
        // 			trace(e)
      });
    }

    advance() {
      const component = this;

      gsap.to(component.slides, { autoAlpha: 0 });
      gsap.to(component.slides[component.current_index], { autoAlpha: 1 });

      component.indicators.forEach(function (element, index, array) {
        element.classList.toggle("active", index == component.current_index);
      });
    }
  }
);

//TESTIMONIAL VIDEOS
customElements.define(
  "xomd-testimonial-videos",
  class extends HTMLElement {
    slides;
    videos;
    current_video;

    constructor() {
      super();
    }

    //fires when component is attached to DOM

    connectedCallback() {
      const component = this;
      const nextButton = document.querySelector(".testimonial-videos-next");
      const prevButton = document.querySelector(".testimonial-videos-prev");
      component.slides = component.querySelectorAll(
        ".testimonial-videos-slide"
      );
      component.videos = component.querySelectorAll(
        ".testimonial-videos-slide video"
      );
      let windowWidth = window.innerWidth;

      component.slides.forEach(function (element, index, array) {
        element.addEventListener("click", function () {
          component.current_video = element.querySelector("video");
          const is_playing =
            component.current_video.currentTime > 0 &&
            !component.current_video.paused &&
            !component.current_video.ended &&
            component.current_video.readyState > 2;
          if (is_playing) {
            component.pauseVideo();
          } else {
            component.playVideo();
          }
        });
      });

      component.videos.forEach(function (element, index, array) {
        const new_node = document.createElement("div");
        new_node.classList.add("testimonial-videos-poster");
        new_node.style.backgroundImage = "url('" + element.poster + "')";
        element.parentNode.insertBefore(new_node, element.nextSibling);

        element.addEventListener("ended", function () {
          this.closest(".testimonial-videos-slide").classList.remove("playing");
          this.currentTime = 0;
        });
      });

      component
        .querySelector(".testimonial-videos-prev")
        .addEventListener("click", function (e) {
          let current_index = parseInt(
            component.getAttribute("data-xomd-index")
          );
          component.setAttribute(
            "data-xomd-index",
            Math.max(0, current_index - 1)
          );

          if (current_index <= 1) {
            prevButton.classList.add("hide-nav-button");
            nextButton.classList.remove("hide-nav-button");
          } else {
            prevButton.classList.remove("hide-nav-button");
            nextButton.classList.remove("hide-nav-button");
          }
        });
      component
        .querySelector(".testimonial-videos-next")
        .addEventListener("click", function (e) {
          let videos = parseInt(component.getAttribute("data-xomd-videos"));
          let max_index = window.innerWidth < 750 ? videos - 1 : videos - 3;
          let current_index = parseInt(
            component.getAttribute("data-xomd-index")
          );

          component.setAttribute(
            "data-xomd-index",
            Math.min(max_index, current_index + 1)
          );

          if (
            current_index >=
            component.slides.length - (windowWidth > 750 ? 4 : 2)
          ) {
            nextButton.classList.add("hide-nav-button");
            prevButton.classList.remove("hide-nav-button");
          } else {
            nextButton.classList.remove("hide-nav-button");
            prevButton.classList.remove("hide-nav-button");
          }
        });

      window.addEventListener("resize", function (e) {
        let videos = parseInt(component.getAttribute("data-xomd-videos"));
        let max_index = window.innerWidth < 750 ? videos - 1 : videos - 3;
        let current_index = parseInt(component.getAttribute("data-xomd-index"));

        component.setAttribute(
          "data-xomd-index",
          Math.min(max_index, current_index)
        );
        trace(e);
      });
    }

    playVideo() {
      const component = this;

      //pause all other videos:
      component.videos.forEach(function (element, index, array) {
        element.pause();
      });
      component.slides.forEach(function (element, index, array) {
        element.classList.remove("playing");
      });

      component.current_video.play();
      component.current_video
        .closest(".testimonial-videos-slide")
        .classList.add("playing");
    }
    pauseVideo() {
      const component = this;

      component.current_video.pause();
      component.current_video
        .closest(".testimonial-videos-slide")
        .classList.remove("playing");
    }
  }
);

//PRODUCT TEXT
customElements.define(
  "xomd-product-copy",
  class extends HTMLElement {
    copy;
    toggle;

    constructor() {
      super();
    }

    //fires when component is attached to DOM
    connectedCallback() {
      const component = this;

      const copy = (component.copy = component.querySelector(".product-copy"));
      const toggle = (component.toggle = component.querySelector(
        ".product-copy-toggle"
      ));

      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        copy.classList.toggle("less");
        toggle.querySelector("a").innerText = copy.classList.contains("less")
          ? "READ MORE"
          : "SHOW LESS";
      });

      component.resize();

      window.addEventListener("resize", function (e) {
        component.resize();
      });
    }

    resize() {
      const component = this;

      component.toggle.style.display = component.isEllipsisActive()
        ? "block"
        : "none";
    }

    isEllipsisActive() {
      const component = this;
      const temp = component.copy.cloneNode(true);

      temp.style.position = "fixed";
      temp.style.overflow = "visible";
      temp.style.whiteSpace = "nowrap";
      temp.style.visibility = "hidden";

      component.copy.parentElement.appendChild(temp);

      try {
        const full_height = temp.getBoundingClientRect().height;
        const display_height = component.copy.getBoundingClientRect().height;

        return full_height > display_height;
      } finally {
        temp.remove();
      }
    }
  }
);

customElements.define(
  "xomd-stats-carousel",
  class extends HTMLElement {
    scale_featured = 1.2;
    scale_default = 1.0;
    autoSlideTimeout = null;
    isHovered = false;

    constructor() {
      super();
    }

    connectedCallback() {
      const component = this;
      const d = 0.7;
      const prev = component.querySelector(".prev");
      const next = component.querySelector(".next");
      const track = component.querySelector(".track");
      let animating = false;

      const checkForGray = (array) => {
        const w = window.innerWidth;
        if (w < 750 && w > 574) {
          array.forEach((card, i) => {
            if (i != 1) {
              card.style.opacity = "0.2";
            } else {
              card.style.opacity = "1";
            }
          });
        } else {
          return;
        }
      };

      let slide_width =
        (1 / parseInt(component.getAttribute("data-xomd-length"))) * 100;

      const highlight_at_start = parseInt(
        component.dataset.xomdHighlightedIndex
      );
      //default start is 1:
      if (highlight_at_start == 0) {
        let cards = component.querySelectorAll(".track > div");
        track.insertBefore(cards[cards.length - 1], track.firstChild);
      } else if (highlight_at_start > 1) {
        for (let i = highlight_at_start; i > 1; i--) {
          let cards = component.querySelectorAll(".track > div");
          track.appendChild(cards[0]);
        }
      }

      window.addEventListener("resize", function (e) {
        resize();
      });

      resize();
      reset();

      const go_to_next = () => {
        if (animating) {
          return;
        }

        animating = true;

        let cards = component.querySelectorAll(".track > div");
        gsap.to(cards, {
          duration: d,
          left: "-=" + slide_width + "%",
          autoAlpha: 0.2,
          scale: component.scale_default,
          ease: "power2.inOut",
          opacity: component.op_default,
        });
        gsap.to(cards[2], {
          duration: d,
          autoAlpha: 1,
          scale: component.scale_featured,
          ease: "power2.inOut",
          opacity: component.op_featured,
        });
        gsap.to([cards[1], cards[3]], {
          duration: d,
          autoAlpha: 1,
          ease: "power2.inOut",
          onComplete: function () {
            track.appendChild(cards[0]);
            reset();
          },
        });
        checkForGray(cards);
      };

      const go_to_prev = () => {
        if (animating) {
          return;
        }

        animating = true;

        let cards = component.querySelectorAll(".track > div");
        track.insertBefore(cards[cards.length - 1], track.firstChild);

        cards = component.querySelectorAll(".track > div");

        gsap.set(cards, {
          left: "-" + slide_width + "%",
          autoAlpha: 0.2,
          scale: component.scale_default,
        });
        gsap.set(cards[2], {
          autoAlpha: 1,
          scale: component.scale_featured,
        });
        gsap.set([cards[1], cards[3]], { autoAlpha: 1 });

        gsap.to(cards, {
          duration: d,
          left: "0%",
          autoAlpha: 0.2,
          scale: component.scale_default,
          ease: "power2.inOut",
        });
        gsap.to(cards[1], {
          duration: d,
          autoAlpha: 1,
          scale: component.scale_featured,
          ease: "power2.inOut",
        });
        gsap.to([cards[0], cards[2]], {
          duration: d,
          autoAlpha: 0.2,
          ease: "power2.inOut",
          onComplete: function () {
            reset();
          },
        });
        checkForGray(cards);
      };

      // Start auto sliding unless hovered
      const autoNext = () => {
        component.autoSlideTimeout = setTimeout(() => {
          if (!component.isHovered) {
            go_to_next();
          }
          autoNext(); // Repeat
        }, 4000);
      };

      autoNext();

      // Pause auto slide on hover
      component.addEventListener("mouseenter", function () {
        component.isHovered = true;
        clearTimeout(component.autoSlideTimeout); // Stop auto sliding
      });

      // Resume auto slide when hover ends
      component.addEventListener("mouseleave", function () {
        component.isHovered = false;
        autoNext(); // Restart auto slide
      });

      prev.addEventListener("click", function (e) {
        go_to_prev();
      });

      next.addEventListener("click", function (e) {
        go_to_next();
      });

      function reset() {
        const cards = component.querySelectorAll(".track > div");
        gsap.set(cards, {
          left: 0,
          autoAlpha: 0,
          scale: component.scale_default,
        });
        gsap.set(cards[1], {
          autoAlpha: 1,
          scale: component.scale_featured,
          opacity: component.op_featured,
        });
        gsap.set([cards[0], cards[2]], { autoAlpha: 1 });

        animating = false;
        checkForGray(cards);
      }

      function resize() {
        const w = window.innerWidth;
        if (w < 576) {
          component.scale_featured = 1.0;
          component.scale_default = 1.0;
        } else if (w < 990) {
          component.scale_featured = 1.0;
          component.scale_default = 0.8;
        } else {
          component.scale_featured = 1.2;
          component.scale_default = 1.0;
        }

        if (!animating) {
          reset();
        }
      }
    }
  }
);

//VIDEO BASIC; used by side-by-side, how-to-use:
customElements.define(
  "xomd-video-basic",
  class extends HTMLElement {
    section;

    constructor() {
      super();
    }

    //fires when component is attached to DOM
    connectedCallback() {
      const component = this;
      const video = component.querySelector("video");
      component.section = component.closest("section");
      const content = component.section.querySelector(".content");

      let timer;

      component.addEventListener("click", function (e) {
        if (video.paused) {
          //pause any other videos playing within the section:
          if (component.section) {
            const section_videos = component.section.querySelectorAll("video");
            section_videos.forEach(function (element) {
              element.pause();
            });
          }

          video.play();
        } else {
          video.pause();
        }
        video.classList.toggle("playing", !video.paused);
        component.section.classList.toggle("playing", !video.paused);
        // video.setAttribute('controls', true);

        if (video.classList.contains("playing")) {
          content.classList.toggle("hide-content");
        }
      });

      component.addEventListener("mousemove", function (e) {
        component.section.classList.add("mouse-moved");

        clearTimeout(timer);
        timer = setTimeout(function () {
          component.section.classList.remove("mouse-moved");
        }, 3000);
      });

      video.addEventListener("ended", function () {
        video.classList.toggle("playing", false);
        component.section.classList.toggle("playing", !video.paused);
      });
      video.addEventListener("pause", function () {
        video.classList.toggle("playing", false);
        if (content) content.classList.remove("hide-content");
        if (component && component.section) component.section.classList.toggle("playing", !video.paused);
      });
      video.addEventListener("play", function () {
        video.classList.toggle("playing", true);
        if (content) content.classList.add("hide-content");
        if (component && component.section) component.section.classList.toggle("playing", !video.paused);
      });
    }
  }
);

///VIDEO MODAL CUSTOM ELEMENTS : this is where the custom video modal video elements are defined

//CLINICAL RESULTS VIDEO MODAL:
customElements.define(
  "xomd-video-modal-overlay",
  class extends HTMLElement {
    video;

    constructor() {
      super();
    }

    //fires when component is attached to DOM
    connectedCallback() {
      const component = this;
      const video = (component.video = component.querySelector("video"));
      const close = component.querySelector(".xomd-video-modal-close");
      let timer;

      component.addEventListener("click", function (e) {
        if (video.paused) {
          //pause any other videos playing within the section:
          // 					const section_videos = component.section.querySelectorAll('video');
          // 					section_videos.forEach(function(element){
          // 						element.pause();
          // 					});

          component.play();
        } else {
          component.pause();
        }
      });

      component.addEventListener("mousemove", function (e) {
        component.classList.add("mouse-moved");

        clearTimeout(timer);
        timer = setTimeout(function () {
          component.classList.remove("mouse-moved");
        }, 3000);
      });

      video.addEventListener("ended", function () {
        component.classList.toggle("playing", false);
      });
      video.addEventListener("pause", function () {
        component.classList.toggle("playing", false);
      });
      video.addEventListener("play", function () {
        component.classList.toggle("playing", true);
      });
      close.addEventListener("click", function (e) {
        e.stopPropagation();
        component.close();
      });
    }

    open() {
      const component = this;
      component.classList.add("show");
      component.play();
    }
    close() {
      const component = this;
      component.pause();
      component.classList.remove("show");
    }
    play() {
      const component = this;
      component.video.play();
      component.classList.toggle("playing", true);
    }
    pause() {
      const component = this;
      component.video.pause();
      component.classList.toggle("playing", false);
    }
  }
);

//INGREDIENTS RESULTS VIDEO MODAL:
customElements.define(
  "xomd-ingredients-video-modal-overlay",
  class extends HTMLElement {
    video;

    constructor() {
      super();
    }

    //fires when component is attached to DOM
    connectedCallback() {
      const component = this;
      const video = (component.video = component.querySelector("video"));
      const close = component.querySelector(".xomd-video-modal-close");
      let timer;

      component.addEventListener("click", function (e) {
        if (video.paused) {
          //pause any other videos playing within the section:
          // 					const section_videos = component.section.querySelectorAll('video');
          // 					section_videos.forEach(function(element){
          // 						element.pause();
          // 					});

          component.play();
        } else {
          component.pause();
        }
      });

      component.addEventListener("mousemove", function (e) {
        component.classList.add("mouse-moved");

        clearTimeout(timer);
        timer = setTimeout(function () {
          component.classList.remove("mouse-moved");
        }, 3000);
      });

      video.addEventListener("ended", function () {
        component.classList.toggle("playing", false);
      });
      video.addEventListener("pause", function () {
        component.classList.toggle("playing", false);
      });
      video.addEventListener("play", function () {
        component.classList.toggle("playing", true);
      });
      close.addEventListener("click", function (e) {
        e.stopPropagation();
        component.close();
      });
    }

    open() {
      const component = this;
      component.classList.add("show");
      component.play();
    }
    close() {
      const component = this;
      component.pause();
      component.classList.remove("show");
    }
    play() {
      const component = this;
      component.video.play();
      component.classList.toggle("playing", true);
    }
    pause() {
      const component = this;
      component.video.pause();
      component.classList.toggle("playing", false);
    }
  }
);

///  END VIDEO MODAL CUSTOM ELEMENTS : this is where the custom video modal video elements are defined

function createSVGElement(tag, target = null) {
  var element = document.createElementNS("http://www.w3.org/2000/svg", tag);
  if (target) {
    target.appendChild(element);
  }
  return element;
}

//#mark -
function trace(c) {
  if (typeof console !== "undefined") {
  }
}


// twopointoh updates - August 2025

//------------------------------------------------------------------------------------------
//
// Custom global swiper initialization
//
//------------------------------------------------------------------------------------------

// ---------- Helpers ----------
function viewportWidth() {
  return window.innerWidth || document.documentElement.clientWidth || 0;
}

function evalResponsiveFlag(val) {
  if (typeof val === 'boolean') return val;
  if (typeof val !== 'string') return null;

  const w = viewportWidth();
  const s = val.trim().toLowerCase();

  let m = s.match(/^max::(\d+)$/);
  if (m) return w <= parseInt(m[1], 10);

  m = s.match(/^min::(\d+)$/);
  if (m) return w >= parseInt(m[1], 10);

  m = s.match(/^(between|range)::(\d+)\s*[-–]\s*(\d+)$/);
  if (m) {
    const a = parseInt(m[2], 10);
    const b = parseInt(m[3], 10);
    const lo = Math.min(a, b);
    const hi = Math.max(a, b);
    return w >= lo && w <= hi;
  }

  return null;
}

function isResponsiveRule(val) {
  return typeof val === 'string' && /^(max|min|between|range)::/i.test(val);
}

function makeRuleWatcher(rule, onFlip) {
  const s = rule.trim().toLowerCase();

  let m = s.match(/^max::(\d+)$/);
  if (m) {
    const n = parseInt(m[1], 10);
    const mq = window.matchMedia(`(max-width: ${n}px)`);
    const listener = () => onFlip(mq.matches);
    mq.addEventListener('change', listener);
    return { unsubscribe() { mq.removeEventListener('change', listener); }, compute() { onFlip(mq.matches); } };
  }

  m = s.match(/^min::(\d+)$/);
  if (m) {
    const n = parseInt(m[1], 10);
    const mq = window.matchMedia(`(min-width: ${n}px)`);
    const listener = () => onFlip(mq.matches);
    mq.addEventListener('change', listener);
    return { unsubscribe() { mq.removeEventListener('change', listener); }, compute() { onFlip(mq.matches); } };
  }

  m = s.match(/^(between|range)::(\d+)\s*[-–]\s*(\d+)$/);
  if (m) {
    const a = parseInt(m[2], 10);
    const b = parseInt(m[3], 10);
    const lo = Math.min(a, b);
    const hi = Math.max(a, b);
    const mqLo = window.matchMedia(`(min-width: ${lo}px)`);
    const mqHi = window.matchMedia(`(max-width: ${hi}px)`);
    const compute = () => onFlip(mqLo.matches && mqHi.matches);
    const listener = () => compute();
    mqLo.addEventListener('change', listener);
    mqHi.addEventListener('change', listener);
    return {
      unsubscribe() {
        mqLo.removeEventListener('change', listener);
        mqHi.removeEventListener('change', listener);
      },
      compute() { compute(); }
    };
  }

  return { unsubscribe() {}, compute() {} };
}

// ---------- Parsing (preserve raw loop rule) ----------
function parseSwiperSettings(carousel) {
  const settings = {
    loop: true,
    centeredSlides: true,
    pagination: { el: '[data-swiper-pagination="true"]', clickable: true },
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
  };

  const id = carousel.getAttribute('data-id');
  if (!id) return settings;

  const settingsEl = document.querySelector(`[data-swiper-settings-for="${id}"]`);
  if (!settingsEl) return settings;

  const elSettings = JSON.parse(settingsEl.textContent || '{}');
  if (!elSettings || Object.keys(elSettings).length === 0) return settings;

  for (const key in elSettings) {
    if (!Object.prototype.hasOwnProperty.call(elSettings, key)) continue;

    if (key === 'loop') {
      const resolved = evalResponsiveFlag(elSettings.loop);
      if (resolved === null) {
        settings.loop = elSettings.loop;         // boolean or unknown string
        settings._rawLoopRule = isResponsiveRule(elSettings.loop) ? elSettings.loop : null;
      } else {
        settings.loop = resolved;                // computed boolean
        settings._rawLoopRule = elSettings.loop; // keep rule string
      }
    } else {
      settings[key] = elSettings[key];
    }
  }

  return settings;
}

// ---------- Init / store / selective re-init ----------
const swiperStore = new WeakMap(); // carousel => { instance, rawLoop, lastLoopBool, unsubscribe }

function buildScopedSettings(carousel, base) {
  const s = { ...base };

  // Scope pagination/nav to this carousel to avoid re-init failures
  if (s.pagination && typeof s.pagination.el === 'string') {
    s.pagination = { ...s.pagination, el: carousel.querySelector(s.pagination.el) || null };
  }
  if (s.navigation) {
    const nextSel = s.navigation.nextEl;
    const prevSel = s.navigation.prevEl;
    s.navigation = {
      ...s.navigation,
      nextEl: typeof nextSel === 'string' ? carousel.querySelector(nextSel) : nextSel,
      prevEl: typeof prevSel === 'string' ? carousel.querySelector(prevSel) : prevSel,
    };
  }

  return s;
}

function initSwiperCarousel(carousel) {
  const parsed = parseSwiperSettings(carousel);

  // Guard: avoid loop on too-few slides
  if (parsed.loop === true) {
    const slideCount = carousel.querySelectorAll('.swiper-slide').length;
    if (slideCount < 2) parsed.loop = false;
    if (parsed.loop) {
      parsed.loopedSlides = slideCount;     // keep indexes stable
      parsed.normalizeSlideIndex = true;
    }
  }

  // --- NEW: init thumbs if configured ---
  if (parsed.thumbs && parsed.thumbs.el) {
    // Find the thumbs element in the same gallery group
    const groupRoot = carousel.closest('.gallery-group--category') || document;
    const thumbsEl = groupRoot.querySelector(parsed.thumbs.el);

    if (thumbsEl) {
      const thumbParams = { ...(parsed.thumbs.params || {}) };
      if (thumbParams.loop == null) thumbParams.loop = false; // thumbs should not loop
      const thumbsInstance = new Swiper(thumbsEl, thumbParams);

      // Swiper expects { swiper: <instance> }
      parsed.thumbs = { swiper: thumbsInstance };
    } else {
      // If not found, drop thumbs config so main still inits
      delete parsed.thumbs;
    }
  }
  // --------------------------------------

  const settings = buildScopedSettings(carousel, parsed);
  const instance = new Swiper(carousel, settings);

  issueVideoSlideChangeEvents(instance, carousel);


  const rawLoop = parsed._rawLoopRule || null;
  const responsive = !!rawLoop && isResponsiveRule(rawLoop);
  const lastLoopBool = responsive ? evalResponsiveFlag(rawLoop) : !!parsed.loop;

  // Store BEFORE wiring watcher so compute() has state
  swiperStore.set(carousel, { instance, rawLoop, lastLoopBool, unsubscribe: null });

  if (responsive) {
    const watcher = makeRuleWatcher(rawLoop, (nowBool) => {
      const state = swiperStore.get(carousel);
      if (!state || state.lastLoopBool === nowBool) return;

      state.instance.destroy(true, true);

      const reParsed = parseSwiperSettings(carousel);
      reParsed.loop = nowBool; // force to current truthiness

      if (nowBool) {
        const slideCount = carousel.querySelectorAll('.swiper-slide').length;
        if (slideCount < 2) reParsed.loop = false;
      }

      const reSettings = buildScopedSettings(carousel, reParsed);
      const newInstance = new Swiper(carousel, reSettings);

      issueVideoSlideChangeEvents(newInstance, carousel);

      swiperStore.set(carousel, {
        instance: newInstance,
        rawLoop: state.rawLoop,
        lastLoopBool: nowBool,
        unsubscribe: state.unsubscribe
      });
    });

    // Now safe to compute (state exists)
    watcher.compute();

    // Save unsubscribe on the stored state
    const current = swiperStore.get(carousel);
    swiperStore.set(carousel, { ...current, unsubscribe: watcher.unsubscribe });
  }
}

function destroySwiperCarousel(carousel) {
  const state = swiperStore.get(carousel);
  if (!state) return;
  if (state.unsubscribe) state.unsubscribe();
  state.instance.destroy(true, true);
  swiperStore.delete(carousel);
}

function handleBulkSwiperInit() {
  const bulkInits = document.querySelectorAll('[data-swiper-init="bulk"]');
  if (!bulkInits.length) return;
  bulkInits.forEach(initSwiperCarousel);
}

function issueVideoSlideChangeEvents(instance, carousel) {
  if (!instance || !instance.on || carousel.dataset.videoSlides !== 'true') return;

  const emit = (type) => {
    const ev = new CustomEvent('video:slides-change', {
      bubbles: true,
      composed: true,
      detail: {
        type,
        carousel,
        swiper: instance,
        activeIndex: instance.activeIndex,
        previousIndex: instance.previousIndex
      }
    });
    carousel.dispatchEvent(ev);
  };

  // fire when a change is locked in (works for arrows/keyboard/autoplay/touch)
  instance.on('slideChangeTransitionStart', () => emit('start'));
  instance.on('slideChangeTransitionEnd',   () => emit('end'));
}


document.addEventListener('DOMContentLoaded', handleBulkSwiperInit);

//------------------------------------------------------------------------------------------
//
// Custom global click handlers
//
//------------------------------------------------------------------------------------------

const globalClickHandlers = new Map([
  ['[data-content-type="video-slide"]', e => handleVideoSlideClick(e.target.closest('[data-content-type="video-slide"]'), e)],
]);

const globalChangeHandlers = new Map([
  ['input[type="radio"][data-tab-group]', (el) => handleTabChange(el)],
]);

document.addEventListener('click', (e) => {
  for (const [selector, handler] of globalClickHandlers) {
      if (e.target.closest(selector)) {
          handler(e);
          break;
      }
  }
});

document.addEventListener('change', (e) => {
  for (const [selector, handler] of globalChangeHandlers) {
    const target = e.target.matches(selector) ? e.target : e.target.closest(selector);
    if (target) {
      handler(target); // pass the INPUT element, not the event
      break;
    }
  }
});

//------------------------------------------------------------------------------------------
//
// UGC Carousel Section
//
//------------------------------------------------------------------------------------------

function handleVideoSlideClick(target) {
  // Pause any other playing videos and do a partial reset on them
  resetActiveVideos(target); 
  initVideoPlayer(target);
}

// Helpers
function getController(root) {
  return root.querySelector('[data-video-controller]');
}
function getVideo(controller) {
  return controller?.querySelector('video') || null;
}
function markPlaying(controller) {
  controller.classList.add('is-playing');
  controller.setAttribute('data-play-active', 'true');
  controller.setAttribute('data-play-started', 'true');
}
function clearPlaying(controller) {
  controller.classList.remove('is-playing');
  controller.removeAttribute('data-play-active');
}

// Remove autoplay/loop attributes so browser won't restart silently
function disableHoverAutoplay(video) {
  video.autoplay = false;
  video.loop = false;
  video.removeAttribute('autoplay');
  video.removeAttribute('loop');
}

// Re-enable hover autoplay as per Liquid defaults
function enableHoverAutoplay(video) {
  video.muted = true;        // required for autoplay
  video.autoplay = true;
  video.loop = true;
  video.setAttribute('autoplay', '');
  video.setAttribute('loop', '');
}

// Partial reset: keep currentTime, no hover autoplay
function partialReset(controller) {
  const video = getVideo(controller);
  if (!video) return;
  clearPlaying(controller);
  video.pause();
  video.controls = false;
  video.muted = true;
  disableHoverAutoplay(video); // keep it frozen at its last frame/time
}

// Full reset: back to idle hover autoplay from the start
function fullReset(controller) {
  controller.removeAttribute('data-play-started');
  const video = getVideo(controller);
  if (!video) return;

  clearPlaying(controller);
  video.pause();
  video.currentTime = 0;
  video.controls = false;
  video.muted = true;

  // restore idle (hover) behavior
  enableHoverAutoplay(video);

  // 🔑 kick muted autoplay back on
  // playsinline helps on iOS
  video.setAttribute('playsinline', '');
  video.play().catch(() => {
    // If something blocks it, we still keep the idle state,
    // but generally muted inline autoplay should succeed.
  });
}


function bindVideoListeners(controller) {
  const video = getVideo(controller);
  if (!video || video.dataset.listenersBound) return;

  video.addEventListener('pause', () => {
    // Guard: in some browsers 'pause' fires before 'ended'
    const nearEnd = video.duration && Math.abs(video.currentTime - video.duration) < 0.25;
    if (!nearEnd) partialReset(controller);
  });

  video.addEventListener('ended', () => {
    fullReset(controller);
  });

  video.dataset.listenersBound = 'true';
}

function initVideoPlayer(target) {
  const controller = getController(target);
  const video = getVideo(controller);
  if (!video) return;

  bindVideoListeners(controller);

  // Enter user-play mode
  disableHoverAutoplay(video); // ensure autoplay/loop attrs are off
  if (controller.getAttribute('data-play-started') !== 'true') video.currentTime = 0;       // user click always restarts from beginning
  video.controls = true;

  markPlaying(controller);

  video.muted = false;

  video.play().catch(err => {
    // Fallback if browser blocks sound
    console.warn('Video play failed, retrying muted:', err);
    video.muted = true;
    video.play().catch(() => {});
  });
}

function resetActiveVideos(target, controller = null) {
  const targetController = controller || getController(target);
  const activeControllers = document.querySelectorAll('[data-video-controller][data-play-active="true"]');
  activeControllers.forEach(ctrl => {
    if (ctrl === targetController) return;
    const vid = getVideo(ctrl);
    if (vid) vid.pause(); // triggers partialReset via pause handler
    else partialReset(ctrl);
  });
}

document.addEventListener('video:slides-change', (e) => {
  resetActiveVideos(null, e.target);
});

//------------------------------------------------------------------------------------------
//
// Cookie Banner State Management
//
//------------------------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  const banner = document.querySelector('cookie-banner, .cookie-banner');
  if (!banner) return;

  const BODY_CLASS = 'cookie-banner-visible';
  const VISIBLE_CLASS = 'is-visible';

  const sync = () => {
    document.body.classList.toggle(BODY_CLASS, banner.classList.contains(VISIBLE_CLASS));
  };

  // Initial + respond to class changes
  sync();
  new MutationObserver(sync).observe(banner, { attributes: true, attributeFilter: ['class'] });
});

//------------------------------------------------------------------------------------------
//
// Image Gallery Tabs
//
//------------------------------------------------------------------------------------------

function handleTabChange(inputEl) {
  if (!inputEl) return;

  const tabGroup = inputEl.dataset.tabGroup || inputEl.name;
  if (!tabGroup) return;

  const tabPanels = document.querySelectorAll(`[data-tab-group-id="${tabGroup}"]`);
  if (!tabPanels.length) return;

  tabPanels.forEach(panel => {
    panel.classList.toggle('hidden', panel.dataset.tabValueCategory !== inputEl.value);
  });
}
